<ng-container *ngIf="viewMode === 'gallery'">
  <div class="gallery-people-container" [class.selected]="selected">
    <div class="avatar-container">
      <ng-container *ngTemplateOutlet="avatar; context: { withClick: true }"></ng-container>
    </div>
    <div class="main-container">
      <div class="main-container-details">
        <ng-container *ngTemplateOutlet="title"></ng-container>
        <ng-container *ngTemplateOutlet="subtitle"></ng-container>
        <div *ngIf="!model.view.subtitle" class="empty-subtitle"></div>
        <ng-container *ngTemplateOutlet="bullets"></ng-container>
        <div class="gallery-buttons">
          <ng-container *ngTemplateOutlet="buttons"></ng-container>
        </div>
      </div>
      <div class="square-button-container">
        <ng-container *ngTemplateOutlet="squareButton"></ng-container>
      </div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewMode === 'small'">
  <div
    #element
    class="relevant-people-item"
    tabindex="-1"
    [dragAndDrop]="dragData"
    [ngClass]="{ 'preview-mode': previewState === 'side', clickable: isClickable }"
  >
    <a>
      <ng-container *ngTemplateOutlet="avatar; context: { size: '36px' }"></ng-container>
    </a>
    <div class="main" #main>
      <div
        class="title-container"
        *ngIf="model.view.title?.text"
        [ngClass]="{ 'preview-mode': previewState === 'side', 'with-subtitle': model.view.subtitle }"
      >
        <ng-container *ngTemplateOutlet="title"></ng-container>
        <ng-container *ngTemplateOutlet="subtitle"></ng-container>
      </div>
    </div>

    <div class="overlay-buttons-container">
      <ng-container *ngTemplateOutlet="squareButton"></ng-container>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="viewMode === 'line'">
  <div
    #element
    class="relevant-people-item"
    tabindex="-1"
    [dragAndDrop]="dragData"
    [ngClass]="{ 'preview-mode': previewState === 'side', clickable: isClickable }"
  >
    <a>
      <ng-container *ngTemplateOutlet="avatar; context: { size: '48px' }"></ng-container>
    </a>
    <div class="main" #main>
      <div
        class="title-container"
        *ngIf="model.view.title?.text"
        [ngClass]="{ 'preview-mode': previewState === 'side', 'with-subtitle': model.view.subtitle }"
      >
        <ng-container *ngTemplateOutlet="title"></ng-container>
        <ng-container *ngIf="false">
          <ng-container *ngTemplateOutlet="favorite"></ng-container>
        </ng-container>
      </div>
      <ng-container *ngTemplateOutlet="bullets"></ng-container>
    </div>

    <div class="overlay-buttons-container">
      <ng-container *featureFlagEnabled="DISABLED_FAVORITES_WORKSPACE_FEATURE_FLAG">
        <ng-container *ngTemplateOutlet="favoriteStar"></ng-container>
      </ng-container>
      <ng-container *ngTemplateOutlet="buttons"></ng-container>

      <ng-container *ngTemplateOutlet="preview"></ng-container>
      <ng-container *ngTemplateOutlet="squareButton"></ng-container>
    </div>
  </div>
  <div class="relevant-people-list" *ngIf="peopleInfo && peopleInfo.contributions">
    <div class="relevant-people-list-header">
      <div class="title">Contributions</div>
      <div class="amount">{{ peopleInfo.contributions.length }}</div>
    </div>
    <result-item
      *ngFor="let item of renderContributions; index as i"
      [class.disabled]="item.deleted"
      [class.selected]="selectedIndex === i"
      [class.hovered]="hoveredIndex === i"
      [sessionId]="sessionId"
      [clientSearchId]="clientSearchId"
      [searchId]="searchId"
      [selected]="selectedIndex === i"
      [pageType]="'relevant_people'"
      class="result-item first-item-margin-top"
      [model]="item"
      tabindex="0"
      [index]="i"
      [resultsIndex]="item.resultIndex"
      [attr.data-index]="i"
      [query]="query"
      [listName]="'relevant_people'"
      [resourceList]="item.resourceList"
      [hovered]="hoveredIndex === i"
      click-invoker
      (invoke)="resultItemOnInvoke($event, 'result', i)"
      [resultsWidth]="windowChange | async"
      [showResultSections]="{
        showFavoriteAction: false,
        showSemantic: false,
        showContextMenu: false,
        showBullets: true,
        showSummaryIcon: false,
        trimSubtitleLength: true,
        showSnippet: false,
        rightClickBlock: true,
        showPreviewIconContextMenu: item?.action?.type !== 'wiki card',
        ignoreHighlights: true,
      }"
    ></result-item>

    <div class="link-button-container" *ngIf="peopleInfo.contributions.length > MIN_LINES">
      <a *ngIf="!maxPages" class="link-button space" target="_blank" (click)="onShowMoreLess('more')">Show more</a>
      <a *ngIf="page > 0" class="link-button black-color" target="_blank" (click)="onShowMoreLess('less')">Show less</a>
    </div>
  </div>
</ng-container>

<ng-template #avatar let-size="size" let-withClick="withClick">
  <ng-container *ngIf="withClick; else normalAvatar">
    <avatar [size]="size ? size : '48px'" [url]="model?.view?.icon" class="clicked" (click)="onAvatarClick()"></avatar>
  </ng-container>
  <ng-template #normalAvatar>
    <avatar [size]="size ? size : '48px'" [url]="model?.view?.icon"></avatar>
  </ng-template>
</ng-template>

<ng-template #title>
  <result-title
    class="relevant-people-title"
    [model]="model.view.title"
    [highlights]="model.highlights"
    [selected]="selected"
    click-invoker
    (invoke)="
      onInvoke({
        command: $event.command,
        context: makeContext({ appId: model.resource.appId, openWith: model.openWith }, $event.context),
        trigger: $event.trigger,
        source: $event.source,
        immediate: $event.immediate,
      })
    "
    #title
  >
  </result-title>
</ng-template>

<ng-template #subtitle>
  <result-subtitle class="relevant-people-subtitle" [model]="model.view.subtitle" [highlights]="model.highlights" click-invoker #subtitle>
  </result-subtitle>
</ng-template>

<ng-template #bullets>
  <div class="bullets-container" tabindex="-1" [ngClass]="{ hidden: previewState === 'side' }" *ngIf="model.view?.bullets?.length > 0">
    <div class="bullet-container" *ngIf="viewMode === 'line'">
      <result-bullet
        tabindex="-1"
        [model]="subtitleBullet"
        (click)="$event.stopPropagation()"
        click-invoker
        (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
        [showDivider]="true"
      >
      </result-bullet>
    </div>
    <div data-cy="result-bullet-container" class="bullet-container" *ngFor="let bullet of model.view.bullets; index as index; last as last">
      <result-bullet
        *ngIf="bullet.parts?.length"
        tabindex="-1"
        [model]="bullet.parts?.length ? bullet : undefined"
        (click)="$event.stopPropagation()"
        click-invoker
        (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
      >
      </result-bullet>
    </div>
    <div class="bullet-container contributions-bullet">
      <result-bullet
        *ngIf="addedBullet && viewMode !== 'line'"
        tabindex="-1"
        [model]="addedBullet"
        (click)="$event.stopPropagation()"
        click-invoker
        (invoke)="onInvoke({ command: $event, trigger: 'mouse_click' })"
      >
      </result-bullet>
    </div>
  </div>
</ng-template>

<ng-template #buttons>
  <div *ngFor="let link of contactLinks | keyvalue; index as i">
    <u-button
      #linkElement
      pTooltip="Direct {{ link.key }} message"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      (onClick)="$event.stopPropagation(); peopleService.directMessage(link.value)"
      type="secondary"
      class="icon-button no-border-button action-button"
      [onlyIcon]="true"
      [ngClass]="{ focused: false }"
    >
      <u-icon [model]="link.value.icon" [styles]="{ width: '14px', height: '14px' }"></u-icon>
    </u-button>
  </div>
  <u-button
    data-cy="copy-email-btn"
    #emailElement
    pTooltip="Copy email"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
    (onClick)="$event.stopPropagation(); peopleService.copyEmail(peopleInfo.details)"
    type="secondary"
    class="icon-button no-border-button action-button"
    [onlyIcon]="true"
    [tabindex]="'-1'"
  >
    <u-icon [model]="{ type: 'font', value: 'icon-envelope' }" [styles]="{ fontSize: '14px' }"></u-icon>
  </u-button>
</ng-template>

<ng-template #squareButton>
  <square-button
    [active]="contextMenuHelper?.source === 'actions'"
    click-invoker
    (click)="$event.stopPropagation(); openContextMenu($event, 'actions')"
    (auxclick)="$event.stopPropagation(); openContextMenu($event, 'actions')"
    (contextmenu)="$event.stopPropagation(); openContextMenu($event, 'actions')"
    #actions
    >•••</square-button
  >
</ng-template>

<ng-template #favorite>
  <div
    class="favorite"
    click-invoker
    *ngIf="
      model.isFavorite &&
      previewState !== 'side' &&
      !showResultSections?.showFavoriteAction &&
      showResultSections.showFavoriteIcon !== false
    "
  >
    <u-icon class="icon" [model]="{ type: 'font', value: 'icon-star-solid' }"></u-icon>
  </div>
</ng-template>

<ng-template #favoriteStar>
  <div
    class="favorite-star"
    click-invoker
    (click)="toggleFavorite('mouse_click'); $event.stopPropagation()"
    *ngIf="showResultSections?.showFavoriteAction"
  >
    <u-icon
      data-cy="people-item-actions-favorite"
      pTooltip="Remove from favorites"
      tooltipPosition="top"
      tooltipStyleClass="u-tooltip"
      [styles]="{ color: 'var(--purple-500)', fontSize: '14px' }"
      [model]="{ type: 'font', value: 'icon-star-solid' }"
    ></u-icon>
  </div>
</ng-template>

<ng-template #preview>
  <u-icon
    data-cy="people-item-actions-preview"
    *ngIf="isPreviewClickAction(model?.action)"
    class="indicate-preview"
    (click)="onPreviewClick(); $event.stopPropagation()"
    [model]="INDICATE_PREVIEW_ICON"
    pTooltip="Preview"
    tooltipPosition="top"
    tooltipStyleClass="u-tooltip"
  ></u-icon>
</ng-template>
